import { render, staticRenderFns } from "./Scholarships.vue?vue&type=template&id=3958f67b&"
import script from "./Scholarships.vue?vue&type=script&lang=ts&"
export * from "./Scholarships.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports